// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3OInu","title":"BackImages_title__22pUa","images":"BackImages_images__1SgWL"};